
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import Pagination from "@components/base/pagination/CenterPagination.vue";
import { getAreaCN } from "@/common/utils";
import { pageViewUnit } from "@/config";
import { myAppealPageList } from "@/api/policy";
@Component({
  name: "SubscribeList",
  components: { Pagination },
})
export default class SubscribeList extends Vue {
  @Getter("id") private id!: string;
  @Action("account/addSubscribe") private addSubscribe: any;
  @Action("account/getSubscribeList") private getSubscribeList: any;
  @Action("account/getSubscribeSetList") private getSubscribeSetList: any;
  setting: any = [];
  active: any = 0;
  base_apply_direction: any = 65;
  dialogVisible: Boolean = false;
  tableData: any = [];
  areaList: any = [];
  departList: any = [];
  keyList: any = [];
  areaOption = this.$root.$data.areaOption;
  pages = 0;
  total = 0;
  size = 10;
  current = 1;
  created() {
    this.getData();
  }
  directionChange(index: any) {
    this.active = index;
    this.getTableData();
  }
  async getBtnData() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    await this.getSubscribeSetList().then(({ code, result, msg }: any) => {
      if (code === 200 && result.length > 0) {
        // 过滤无数据订阅设置
        this.setting = result.filter(
          ({ title, departmentId, addressCode }: any) => {
            return title || departmentId || addressCode;
          }
        );
        loading && loading.close();
        return true;
      }
      loading && loading.close();
      return false;
    });
  }
  async getData() {
    //await this.getBtnData();
    await this.getTableData();
  }
  async getTableData() {
    const options = {
      pageNumber: this.current,
      pageSize: this.size,
    };
    myAppealPageList(options).then((res: any) => {
      const { code, result, msg } = res.data;
      if (code === 200 && result) {
        let { records, total, pages } = result;
        this.total = total;
        this.pages = pages;
        this.tableData = records;
      }
    });
  }
  handleSizeChange(val: any) {}
  handleCurrentChange(val: any) {
    this.current = val;
    this.getData();
  }
}
